/**
 * Network hub-and-spoke API client.
 *
 * Endpoints under /v1/network/, all session-authed.
 */
import { apiClient } from '@/services/api/client';
import type {
  BrowseResponse,
  FirmRelationshipScorecard,
  GlobalGraphResponse,
  HubResponse,
  PersonRelationshipScorecard,
} from '../types/hub';

export async function fetchFirmHub(companyId: string, limit = 12): Promise<HubResponse> {
  return apiClient.get<HubResponse>(`/v1/network/firm/${companyId}/hub?limit=${limit}`);
}

export async function fetchPersonHub(personaId: string, limit = 12): Promise<HubResponse> {
  return apiClient.get<HubResponse>(`/v1/network/person/${personaId}/hub?limit=${limit}`);
}

export async function fetchBrowse(limit = 20): Promise<BrowseResponse> {
  return apiClient.get<BrowseResponse>(`/v1/network/browse?limit=${limit}`);
}

export async function fetchGlobalGraph(
  nodeLimit = 2500,
  edgeLimit = 3000,
): Promise<GlobalGraphResponse> {
  return apiClient.get<GlobalGraphResponse>(
    `/v1/network/global?node_limit=${nodeLimit}&edge_limit=${edgeLimit}`,
  );
}

export async function fetchFirmRelationshipScorecard(
  companyId: string,
): Promise<FirmRelationshipScorecard> {
  return apiClient.get<FirmRelationshipScorecard>(
    `/v1/network/firm/${companyId}/relationship-scorecard`,
  );
}

export async function fetchPersonRelationshipScorecard(
  personaId: string,
): Promise<PersonRelationshipScorecard> {
  return apiClient.get<PersonRelationshipScorecard>(
    `/v1/network/person/${personaId}/relationship-scorecard`,
  );
}
